import { render, staticRenderFns } from "./employee movements.vue?vue&type=template&id=4ab88919&scoped=true"
import script from "./employee movements.vue?vue&type=script&lang=js"
export * from "./employee movements.vue?vue&type=script&lang=js"
import style0 from "./employee movements.vue?vue&type=style&index=0&id=4ab88919&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab88919",
  null
  
)

export default component.exports